export default __webpack_public_path__ + "static/media/cssgridflexbox.1e743ef4.png";